import { render } from "./COC.vue?vue&type=template&id=7d969d53&scoped=true"
import script from "./COC.vue?vue&type=script&lang=js"
export * from "./COC.vue?vue&type=script&lang=js"

import "./COC.vue?vue&type=style&index=0&id=7d969d53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d969d53"

export default script